import React, { Component } from 'react';
import {Grid} from "@material-ui/core";

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
            <Grid container xs={12}>
                <Grid item xs={12}>
                    <hr style={{width:"100%",color:"black"}}/>
                </Grid>
                <Grid item xs={2}>
                    <img  style={{width:"5vw",height:"5vw",borderRadius:"50%"}} src="https://i.ibb.co/9tjG9Sf/myimg.jpg"/>
                </Grid>
                <Grid item container xs={10}>
                    <Grid item xs={12} style={{color:"#808080",margin:0}}>
                       <h6> WRITTEN BY</h6>
                    </Grid>
                    <Grid item xs={12} >
                       <h5 style={{margin:0}}> Ujjwal Sharma </h5>
                    </Grid>
                    <Grid item xs={12} style={{color:"#808080"}}>
                        <h6>Persuing my BTECH + MTECH in Information Technology. Lover of art, music and beautiful things. 
                           An Interested Full Stack Developer and Open to New Opportunities </h6>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <hr style={{width:"100%",color:"#C5C5C5"}}/>
                </Grid>
            </Grid>
         );
    }
}
 
export default Footer;


// WEBPACK FOOTER //
// ./src/components/VIEW/Footer.js